module.exports = __webpack_public_path__ + "img/trash2-fill.dee7c438.svg";